// Phone and how-did-you-hear are required on every tour and program request (owner direction,
// Sept 30). A phone number needs 10 digits (11 with a leading 1), written any common way.
export const PHONE_INPUT = {
  type: 'tel', autoComplete: 'tel', inputMode: 'tel', required: true,
  pattern: '[\\s\\(\\)\\.\\+\\-]*(\\d[\\s\\(\\)\\.\\+\\-]*){10,11}',
  'data-message': 'Please enter a 10-digit phone number.',
};
// "Email: Please enter…", or "How did you hear about us? Please choose…" for question labels.
export const fieldMessage = (field) => {
  const label = field.labels?.[0]?.textContent.replace(' *', '') || 'Field';
  return `${label}${label.endsWith('?') ? '' : ':'} ${field.dataset.message || field.validationMessage}`;
};
